// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetDeepcoinMarketBooks (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketCandles (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketInstruments (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketTickers (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketIndexCandles (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketTrades (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketMarkPriceCandles (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinMarketStepMargin (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinTradeFundingRate (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinTradeFundRateCurrentFundingRate (params?: {}): Promise<implicitReturnType>;
    publicGetDeepcoinTradeFundRateHistory (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAccountBalances (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAccountBills (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAccountPositions (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeFills (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeOrderByID (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeFinishOrderByID (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeOrdersHistory (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeV2OrdersPending (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeTriggerOrdersPending (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinTradeTriggerOrdersHistory (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinCopytradingSupportContracts (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinCopytradingLeaderPosition (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinCopytradingEstimateProfit (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinCopytradingHistoryProfit (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinCopytradingFollowerRank (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinInternalTransferSupport (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinInternalTransferHistoryOrder (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinRebateConfig (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAgentsUsers (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAgentsUsersRebateList (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAgentsUsersRebates (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAssetDepositList (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAssetWithdrawList (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinAssetRechargeChainList (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinListenkeyAcquire (params?: {}): Promise<implicitReturnType>;
    privateGetDeepcoinListenkeyExtend (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinAccountSetLeverage (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeOrder (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeReplaceOrder (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeCancelOrder (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeBatchCancelOrder (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeCancelTriggerOrder (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeSwapCancelAll (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeTriggerOrder (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeBatchClosePosition (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeReplaceOrderSltp (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinTradeClosePositionByIds (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinCopytradingLeaderSettings (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinCopytradingSetContracts (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinInternalTransfer (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinRebateConfig (params?: {}): Promise<implicitReturnType>;
    privatePostDeepcoinAssetTransfer (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
